import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import router from './router'
import { configureAuth } from '@/config/auth'
import { useAuthStore } from '@/store/auth.store'
import './assets/main.css'

configureAuth()

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

// Restore session on app load
const authStore = useAuthStore(pinia)
authStore.checkAuth().catch(() => {
  // Ignore session restoration errors (e.g., not signed in)
})

app.config.errorHandler = (err, instance, info) => {
  const errorMessage = err instanceof Error ? err.message : String(err)
  console.error(`Error: ${errorMessage}\nInfo: ${info}`)

  if (err instanceof Error && err.name !== 'ValidationError') {
    alert(`An error occurred: ${errorMessage}`)
    router.push('/')
  }
}

app.use(pinia)
app.use(router)
app.mount('#app')
